import missionAllowList from "../../config/MissionAllowList";

const isNonEmptyString = (value) =>
  typeof value === "string" && value.length > 0;

const isValidMission = (mission) =>
  mission &&
  typeof mission === "object" &&
  isNonEmptyString(mission.missionId);

const isValidAllowListEntry = (entry) =>
  entry &&
  typeof entry === "object" &&
  Array.isArray(entry.missionIds) &&
  Array.isArray(entry.missionNames) &&
  Array.isArray(entry.missionNamePatterns);

const matchesAllowList = (mission, entry) => {
  if (!isValidMission(mission) || !isValidAllowListEntry(entry)) {
    return false;
  }

  if (entry.missionIds.includes(mission.missionId)) {
    return true;
  }

  if (isNonEmptyString(mission.missionName) &&
      entry.missionNames.includes(mission.missionName)) {
    return true;
  }

  return isNonEmptyString(mission.missionName) &&
    entry.missionNamePatterns.some(
      (pattern) => isNonEmptyString(pattern) &&
        mission.missionName.includes(pattern)
    );
};

const getProviderAllowList = (providerKey, configuration) => {
  if (!configuration || typeof configuration !== "object") {
    return null;
  }

  const entry = configuration[providerKey];
  return isValidAllowListEntry(entry) ? entry : null;
};

const filterMissions = (
  missions,
  providerKey,
  { isDeaAdmin = false, isDeaOverallMode = false } = {},
  configuration = missionAllowList
) => {
  if (!Array.isArray(missions)) {
    return [];
  }

  if (isDeaAdmin && isDeaOverallMode) {
    return deduplicateMissions(missions);
  }

  const entry = getProviderAllowList(providerKey, configuration);
  if (!entry) {
    return [];
  }

  return deduplicateMissions(
    missions.filter((mission) => matchesAllowList(mission, entry))
  );
};

const deduplicateMissions = (missions) => {
  const seenMissionIds = new Set();

  return missions.filter((mission) => {
    if (!isValidMission(mission) || seenMissionIds.has(mission.missionId)) {
      return false;
    }

    seenMissionIds.add(mission.missionId);
    return true;
  });
};

export {
  deduplicateMissions,
  filterMissions,
  getProviderAllowList,
  matchesAllowList,
};


